import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema, trackerRedirectSchema } from './schemas';

export const smartRulesSearchParams = new SearchParams(screenSchema);

export const smartRulesLink = new Link('smart-rules', smartRulesSearchParams);

export const smartRulesDetailsLink = smartRulesLink.child(':id');

export const smartRulesTrackerRedirectParams = new SearchParams(
  trackerRedirectSchema
);

export const smartRulesTrackerRedirectLink = smartRulesLink.child(
  'tracker-redirect/:id',
  smartRulesTrackerRedirectParams
);

export const smartRulesActionCallbackLink = smartRulesLink.child(
  'action-callback'
);
